import Client from '../client';
import {flattenObject} from '../helpers';
import {
  GetTokensBuilder,
  GetTokenBuilder,
  RenewTokenBuilder,
  RevokeTokenBuilder,
  GetShopInfoBuilder,
  InitializeBasalamOAuthBuilder,
  RegisterShopUrlBuilder,
  RegisterBasalamTokenBuilder,
} from '../tokens/tokens';

const token = localStorage.getItem('token') || '';

class TokensRepository {
  getTokens = async (actions: any) => {
    const {id, ...actionsPayload} = actions.payload;
    const makeRequest = new GetTokensBuilder()
      .id(id)
      .params(flattenObject({...actionsPayload, sort: 'id,desc'}))
      .build();

    const client = new Client(token);
    const response = await client.execute(makeRequest);
    return {response};
  };

  getToken = async (actions: any) => {
    const {id, ...actionsPayload} = actions.payload;
    const makeRequest = new GetTokenBuilder()
      .id(id)
      .params(flattenObject({...actionsPayload, sort: 'id,desc'}))
      .build();

    const client = new Client(token);
    const response = await client.execute(makeRequest);
    return {response};
  };

  renewToken = async (actions: any) => {
    const {id, ...actionsPayload} = actions.payload;
    const makeRequest = new RenewTokenBuilder()
      .id(id)
      .data(flattenObject({...actionsPayload}))
      .build();

    const client = new Client(token);
    const response = await client.execute(makeRequest);
    return {response};
  };

  revokeToken = async (actions: any) => {
    const {id, callback, ...actionsPayload} = actions.payload;
    const makeRequest = new RevokeTokenBuilder()
      .id(id)
      .params(flattenObject({...actionsPayload}))
      .build();

    const client = new Client(token);
    const response = await client.execute(makeRequest);
    return {response, callback};
  };

  getShopInfo = async () => {
    const makeRequest = new GetShopInfoBuilder()
      .build();

    const client = new Client(token);
    const response = await client.execute(makeRequest);
    return response;
  };

  InitializeBasalamOAuth = async () => {
    const makeRequest = new InitializeBasalamOAuthBuilder()
      .build();

    const client = new Client(token);
    const response = await client.execute(makeRequest);
    return response;
  };

  RegisterShopUrl = async (actions: any) => {
    const {...actionsPayload} = actions.payload;
    const makeRequest = new RegisterShopUrlBuilder()
      .data(flattenObject({...actionsPayload}))
      .build();

    const client = new Client(token);
    const response = await client.execute(makeRequest);
    return response;
  };

  RegisterBasalamToken = async (actions: any) => {
    const {code} = actions.payload;
    const makeRequest = new RegisterBasalamTokenBuilder()
      .params({code})
      .build();

    const client = new Client(token);
    const response = await client.execute(makeRequest);
    return response;
  };
}

export default new TokensRepository();
